import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h5" }
const _hoisted_2 = { class: "text-body1" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "text-h5" }
const _hoisted_5 = { class: "text-body1" }
const _hoisted_6 = { class: "text-h5" }
const _hoisted_7 = { class: "text-body1" }
const _hoisted_8 = ["innerHTML"]

import { format, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { useI18n } from "vue-i18n"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogDevicePermission',
  setup(__props) {

const { t } = useI18n()
const { dialogRef, onDialogOK } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    persistent: true,
    class: "sfx-dialog-permission"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createTextVNode(". "),
          _createVNode(_component_q_card_section, { class: "row flex-center text-h3" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("sfxDialogDevicePermission.title")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-center text-body1 q-pb-none" }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)("sfxDialogDevicePermission.info_text_1")), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)("sfxDialogDevicePermission.info_text_2")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "row flex-center q-pb-none" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _unref(Icons).CHECKBOX_CHECKED,
                size: "96px",
                class: "text-line-and-filler"
              }, null, 8, ["name"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_1, [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogDevicePermission.video_title")) + " ", 1),
                  _createElementVNode("ul", _hoisted_2, [
                    _createElementVNode("li", {
                      innerHTML: _unref(t)('sfxDialogDevicePermission.video_text_1')
                    }, null, 8, _hoisted_3),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)("sfxDialogDevicePermission.video_text_2")), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogDevicePermission.storage_title")) + " ", 1),
                  _createElementVNode("ul", _hoisted_5, [
                    _createElementVNode("li", null, _toDisplayString(_unref(t)("sfxDialogDevicePermission.storage_text")), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogDevicePermission.location_title")) + " ", 1),
                  _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", {
                      innerHTML: _unref(t)('sfxDialogDevicePermission.location_text')
                    }, null, 8, _hoisted_8)
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: _unref(format).capitalize(_unref(t)('sfxButtons.btn_ok')),
                class: "col-grow"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})